<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: ['values', 'labels'],
  mounted () {
    this.renderChart({
      labels: this.labels,
      datasets: [
        {
          backgroundColor: this.getColors(this.values.length),
          data: this.values
        }
      ]
    })
  },
  methods: {
    getColors (amount) {
      let baseColors = [
        '#FFC312',
        '#A3CB38',
        '#0652DD',
        '#6F1E51',
        '#EA2027',
        '#009432',
        '#EE5A24',
        '#12CBC4',
        '#FDA7DF',
        '#F79F1F',
        '#ED4C67'
      ]

      return this.$_.chunk(baseColors, amount)[0]
    }
  }
}
</script>
